export default __webpack_public_path__ + "static/hummingbird-cbba09a1f03a526c92bd964951693a02.svg";